var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientModal2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{stroke:#707070;opacity:0;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10452 3268)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-10452 -3268)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10455.2 -3264)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.034,0h-10A1.832,1.832,0,0,0,8.2,1.83V15.17A1.832,1.832,0,0,0,10.03,17h10a1.832,1.832,0,0,0,1.83-1.83V1.83A1.832,1.832,0,0,0,20.034,0Zm.61,15.17a.61.61,0,0,1-.61.61h-10a.61.61,0,0,1-.61-.61V1.83a.611.611,0,0,1,.61-.61h10a.61.61,0,0,1,.61.61V15.17Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 7.93,
    height: 1.22,
    transform: "translate(11.067 4.338)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 7.93,
    height: 1.22,
    transform: "translate(11.067 7.633)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 7.93,
    height: 1.22,
    transform: "translate(11.067 10.927)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientModal2);
export default __webpack_public_path__ + "static/media/clientModal2.16249d1e9cf429073eb936f2258cf28a.svg";
export { ForwardRef as ReactComponent };